/**
 * A point that can be a real site, or nothing.
 *
 * Old surveys carry a placeholder map centre of 0,0 (open ocean; Google answers it with "Sorry, we
 * have no imagery here"), and a stray write can leave NaN or a swapped pair. None of these is a
 * place to open a map on. The Sales app applies the same rule in its own
 * `surveyStartCenter.realPoint`; this is the copy the shared editor and the main app's hosts use.
 */
export interface LatLng {
  readonly lat: number;
  readonly lng: number;
}

export interface MaybeLatLng {
  readonly lat?: unknown;
  readonly lng?: unknown;
}

export function realLatLng(point: MaybeLatLng | null | undefined): LatLng | undefined {
  if (!point) return undefined;
  const { lat, lng } = point;
  if (typeof lat !== 'number' || typeof lng !== 'number') return undefined;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return undefined;
  if (lat === 0 && lng === 0) return undefined;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return undefined;
  return { lat, lng };
}
